<template>
    <SignUp></SignUp>
    <Footer></Footer>
</template>

<script>
  import SignUp from '@/components/user/SignUp.vue'
  import Footer from '@/components/Footer.vue'

import {mapGetters,mapActions} from 'vuex'
  export default {
    components: {
        SignUp,
        Footer
    },
      computed: {
        ...mapGetters([
            'isMobile'
        ]),
    },
  }
</script>

